import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { MessageCircle, Send, User as UserIcon } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";

export default function DealRoom({ opportunityId }) {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [msg, setMsg] = useState("");

  const load = () => api.get(`/deal-room/${opportunityId}`).then((r) => setItems(r.data.items || []));
  useEffect(() => { load(); }, [opportunityId]);

  const post = async (e) => {
    e.preventDefault();
    if (!msg.trim()) return;
    await api.post(`/deal-room/${opportunityId}`, { message: msg.trim() });
    setMsg("");
    load();
  };

  return (
    <div className="border border-[#33291f] rounded-lg bg-[#1c1712] p-5" data-testid="deal-room">
      <h3 className="font-display text-lg font-semibold mb-4 flex items-center gap-2"><MessageCircle size={16} className="text-[#d4a574]" /> Deal Room</h3>
      <div className="space-y-3 mb-4 max-h-[360px] overflow-y-auto pr-1">
        {items.length === 0 && <div className="text-[12px] text-[#7a6d5a] italic">No discussion yet. Start the conversation with your team.</div>}
        {items.map((c) => (
          <div key={c.id} data-testid={`deal-comment-${c.id}`} className="flex gap-3">
            <div className="w-8 h-8 rounded-full bg-[#241d16] border border-[#4a3a2b] flex items-center justify-center text-[#d4a574] text-[13px] font-semibold shrink-0">
              {c.user_name?.[0] || "U"}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-baseline gap-2">
                <span className="text-[13px] font-semibold">{c.user_name}</span>
                {c.user_company && <span className="text-[10px] text-[#7a6d5a]">{c.user_company}</span>}
                <span className="text-[10px] font-mono text-[#7a6d5a] ml-auto">{c.created_at?.slice(11, 16)}</span>
              </div>
              <div className="text-[13px] text-[#b8ac96] leading-relaxed mt-0.5 whitespace-pre-wrap">{c.message}</div>
            </div>
          </div>
        ))}
      </div>
      <form onSubmit={post} className="flex gap-2 border-t border-[#33291f] pt-4" data-testid="deal-room-form">
        <Textarea rows={2} value={msg} onChange={(e) => setMsg(e.target.value)} data-testid="deal-room-input" placeholder="Message your team about this opportunity…" className="bg-[#241d16] border-[#33291f] text-[13px] resize-none" />
        <button type="submit" data-testid="deal-room-send" className="px-4 rounded bg-[#d4a574] text-[#14100c] hover:bg-[#e8b988] font-semibold text-[13px] flex items-center gap-1.5 shrink-0"><Send size={13} /> Send</button>
      </form>
    </div>
  );
}
